import React from 'react';
import PropTypes from 'prop-types';
import memoizeOne from 'memoize-one';
import OverviewTable from '../components/Table/OverviewTable';
import localization from '../i18n/localization';

const columnDefinition = [
  { id: 'email', label: 'Email' },
  { id: 'emailVerified', label: 'Email verifiziert' },
  { id: 'roles', label: 'Rollen' },
];

const transform = memoizeOne(tenants =>
  tenants.map(tenant => ({
    id: tenant.id,
    email: tenant.email,
    emailVerified: tenant.emailVerified ? '\u2713' : '\u2715',
    roles: tenant.roles.map(role => localization.de[role]).join(', '),
  }))
);

export default function TenantOverviewTable({ tenants, onUserClick }) {
  return (
    <OverviewTable
      columnDefinition={columnDefinition}
      data={transform(tenants)}
      onRowClick={tenant => onUserClick(tenant.email)}
    />
  );
}

TenantOverviewTable.defaultProps = {
  tenants: [],
};

TenantOverviewTable.propTypes = {
  tenants: PropTypes.array,
  onUserClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/auth/TenantOverviewTable.jsx